import { useCallback } from 'react'

import { useNavigate } from '@tanstack/react-router'

/**
 * Navigates to a path, handling the case where the user is already on the
 * target page. When search params are present and the pathname matches,
 * TanStack Router won't re-navigate, so nuqs never detects the new params.
 * This hook works around that by pushing state directly and dispatching a
 * popstate event so nuqs picks up the change.
 * e.g. using "Create Contact" while already on /contacts:
 * TanStack Router won't re-navigate to the same route, so
 * nuqs never sees ?trigger=create and the modal won't open.
 */
export function useNavigateWithSearchParams() {
  const navigate = useNavigate()

  return useCallback(
    (path: string) => {
      const url = new URL(path, window.location.origin)
      const pathname = url.pathname
      const search = url.search

      if (window.location.pathname === pathname && search) {
        window.history.pushState(window.history.state, '', pathname + search)
        window.dispatchEvent(new PopStateEvent('popstate'))
      } else {
        navigate({ to: path })
      }
    },
    [navigate],
  )
}
